import { Button, CheckCard } from "@/components";
import { FONT, RADIUS } from "@/styles/common";
import { Divider, Flex, Spinner, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useCompletedRoomState, useNewNavigate, usePaidMethodRecoilValue } from "@shared/client";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { CompleteCatchPraise } from "../components";

export const Complete = () => {
    const [completedRoom, setCompletedRoom] = useCompletedRoomState();
    const [isLoading, setIsLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const { onNavigate } = useNewNavigate();
    const orderNum = searchParams.get("orderNum");
    const paidMethodValue = usePaidMethodRecoilValue();
    const paidMethodFromSessionStorage = sessionStorage.getItem("paidMethod");

    useEffect(() => {
        if (paidMethodValue) sessionStorage.setItem("paidMethod", paidMethodValue);
    }, [paidMethodValue]);

    useEffect(() => {
        if (orderNum) {
            const savedCompletedData = sessionStorage.getItem(orderNum);
            if (savedCompletedData) setCompletedRoom(JSON.parse(savedCompletedData));
        }

        setIsLoading(false);
    }, [orderNum]);

    if (isLoading) {
        return (
            <Flex w="100%" justifyContent="center" alignItems="center" h="100vh">
                <Spinner size="xl" />
            </Flex>
        );
    }

    return (
        <>
            <Helmet>
                <title>Marginmax | 결제내역</title>
            </Helmet>
            {completedRoom ? (
                <Flex w="100%" alignItems="flex-start" flexDir="column" gap="24px">
                    <CustomCompletedPaidText>
                        {paidMethodValue === "account" || paidMethodFromSessionStorage === "account"
                            ? "신청 완료"
                            : "예약 완료"}
                    </CustomCompletedPaidText>
                    <CustomFlex w="100%" padding="24px" flexDir="column" gap="24px">
                        <Flex w="100%" flexDir="column" rowGap="32px">
                            {completedRoom.roomList.map((room) => (
                                <CheckCard key={room.roomName} roomList={room} status={completedRoom.status} />
                            ))}
                        </Flex>
                        <CustomDivider />
                        <CompleteCatchPraise
                            orderNum={completedRoom.orderNum}
                            orderName={completedRoom.orderName}
                            roomList={completedRoom.roomList}
                            pay_memo={completedRoom.pay_memo}
                            payMethod={completedRoom.payMethod}
                        />
                    </CustomFlex>
                </Flex>
            ) : (
                <Flex flexDir="column">
                    <Text>oops...! 세션이 만료 되었어요.</Text>
                    <Button onClick={() => onNavigate({ path: "/status" })}>예약페이지로 가기</Button>
                </Flex>
            )}
        </>
    );
};

const CustomCompletedPaidText = styled(Text)`
    ${FONT("pretendard", 24, 700)}
`;

const CustomFlex = styled(Flex)`
    border: 1px solid;
    border-color: ${({ theme }) => theme.COLOR.gray[300]};
    ${RADIUS(4)}
`;

const CustomDivider = styled(Divider)`
    color: ${({ theme }) => theme.COLOR.gray[300]};
`;
